import React, { Component } from 'react';
import { connect } from 'shalala';
import { Dropdown } from 'react-bootstrap';

import { useStore } from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';
import AutofacturacionTicketStatus from '../../enum/AutofacturacionTicketStatus';

class AutofacturacionTicketFilter extends Component {
  state = {};
  timerId = null;

  handleOnSelectComprobanteFilter = (name, filter) => {
    this.setState({
      [name]: filter !== '' ? filter : '',
    });

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.timerId = setTimeout(() => {
      this.submit();
    }, 1000);
  };

  submit = () => {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    const { pagination } = this.props;

    this.props.paginate({
      ...pagination,
      ...this.state,
    });
  };

  getStatusLegend = () => {
    const { status = '' } = this.state;
    let legend = 'Todos';

    switch (status) {
      case '':
        legend = 'Todos';
        break;
      case AutofacturacionTicketStatus.pending().getValue().toString():
        legend = AutofacturacionTicketStatus.pending().getName().toString();
        break;

      case AutofacturacionTicketStatus.success().getValue().toString():
        legend = AutofacturacionTicketStatus.success().getName().toString();
        break;

      case AutofacturacionTicketStatus.error().getValue().toString():
        legend = AutofacturacionTicketStatus.error().getName().toString();
        break;

      case AutofacturacionTicketStatus.failed().getValue().toString():
        legend = AutofacturacionTicketStatus.failed().getName().toString();
        break;

      case AutofacturacionTicketStatus.duplicate().getValue().toString():
        legend = AutofacturacionTicketStatus.duplicate().getName().toString();
        break;

      case AutofacturacionTicketStatus.reserved().getValue().toString():
        legend = AutofacturacionTicketStatus.reserved().getName().toString();
        break;

      case AutofacturacionTicketStatus.fpg().getValue().toString():
        legend = AutofacturacionTicketStatus.fpg().getName().toString();
        break;

      case AutofacturacionTicketStatus.queued().getValue().toString():
        legend = AutofacturacionTicketStatus.queued().getName().toString();
        break;

      case AutofacturacionTicketStatus.individual().getValue().toString():
        legend = AutofacturacionTicketStatus.individual().getName().toString();
        break;

      case AutofacturacionTicketStatus.blocked().getValue().toString():
        legend = AutofacturacionTicketStatus.blocked().getName().toString();
        break;
      case AutofacturacionTicketStatus.unprocessed().getValue().toString():
        legend = AutofacturacionTicketStatus.unprocessed().getName().toString();
        break;
      case AutofacturacionTicketStatus.cancelled().getValue().toString():
        legend = AutofacturacionTicketStatus.cancelled().getName().toString();
        break;

      default:
        break;
    }

    return legend;
  };

  render() {
    return (
      <div className="mb-1 float-left">
        <Dropdown
          onSelect={this.handleOnSelectComprobanteFilter.bind(this, 'status')}
          className="float-left mr-1 pb-2"
        >
          <Dropdown.Toggle as={CustomDropdownToggle}>{this.getStatusLegend() || 'Status'}</Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Todos</Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.pending().getValue()}>
              {AutofacturacionTicketStatus.pending().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.success().getValue()}>
              {AutofacturacionTicketStatus.success().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.error().getValue()}>
              {AutofacturacionTicketStatus.error().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.failed().getValue()}>
              {AutofacturacionTicketStatus.failed().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.duplicate().getValue()}>
              {AutofacturacionTicketStatus.duplicate().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.reserved().getValue()}>
              {AutofacturacionTicketStatus.reserved().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.fpg().getValue()}>
              {AutofacturacionTicketStatus.fpg().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.queued().getValue()}>
              {AutofacturacionTicketStatus.queued().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.individual().getValue()}>
              {AutofacturacionTicketStatus.individual().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.blocked().getValue()}>
              {AutofacturacionTicketStatus.blocked().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.unprocessed().getValue()}>
              {AutofacturacionTicketStatus.unprocessed().getName()}
            </Dropdown.Item>
            <Dropdown.Item eventKey={AutofacturacionTicketStatus.cancelled().getValue()}>
              {AutofacturacionTicketStatus.cancelled().getName()}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

const mapState = (store) => {
  return store.modulo.autofacturacion.tickets;
};

const mapActions = (actions) => {
  return actions.modulo.autofacturacion.tickets;
};

export default connect(useStore, mapState, mapActions)(AutofacturacionTicketFilter);
